import { createContext, Component } from '@wordpress/element';
import data from '../data/new-data.json';

const UserContext = createContext();

class UserProvider extends Component {
	state = {
		selectedParent: 'Politics & Elections',
		selectedChildName: 'Trump approval',
		selectedChild: data.issues[0].children[0],
		selectedView: 'key topics',
		issues: data.issues,
		types: data.types,
	};

	updateParent = (selectedParent) => {
		this.setState({ selectedParent });
	};

	updateChild = (selectedChild) => {
		this.setState({ selectedChild });
		const match = this.findMatchingParent(selectedChild.slug);
		if (match) {
			this.setState({ selectedParent: match.parent });
		}
	};

	updateView = (selectedView) => {
		this.setState({ selectedView: selectedView.toLowerCase() });
	};

	findMatchingParent = (slug) => {
		const parent = this.state.issues.find((issue) =>
			issue.children.some((child) => child.slug === slug)
		);
		return parent;
	};

	/**
	 * Select the issue row matching a URL slug (e.g. prcFeatureUrlParamA).
	 *
	 * @param {string|null|undefined} slug Child slug from the URL.
	 * @return {{ issueIndex: number, issue: object, child: object } | null} Index and objects when matched; otherwise null.
	 */
	selectChildBySlug = (slug) => {
		if (!slug) {
			return null;
		}
		const normalized = String(slug).trim();
		const { issues } = this.state;
		for (let i = 0; i < issues.length; i++) {
			const issue = issues[i];
			const child = issue.children.find(
				(c) => c.slug.trim() === normalized
			);
			if (child) {
				const selectedView =
					issue.parent_slug === 'demographics'
						? 'demographics'
						: 'key topics';
				this.setState({
					selectedParent: issue.parent,
					selectedChildName: child.name,
					selectedChild: child,
					selectedView,
				});
				return { issueIndex: i, issue, child };
			}
		}
		return null;
	};

	render() {
		const { children } = this.props;
		const { updateParent, updateChild, updateView, selectChildBySlug } =
			this;
		const { selectedParent, selectedChild, selectedView, issues, types } =
			this.state;

		return (
			<UserContext.Provider
				value={{
					selectedParent,
					selectedChild,
					selectedView,
					issues,
					updateParent,
					updateChild,
					updateView,
					selectChildBySlug,
					types,
				}}
			>
				{children}
			</UserContext.Provider>
		);
	}
}

export default UserContext;

export { UserProvider };
